export default function TdsStatCard({ label, value, icon: Icon, accent, bg, color }) {
  return (
    <div
      className="tds-stat-card"
      style={{
        "--stat-accent": accent,
        "--stat-bg": bg,
        "--stat-color": color,
      }}
    >
      {Icon ? (
        <div className="tds-stat-icon">
          <Icon size={18} strokeWidth={2} />
        </div>
      ) : null}
      <div className="tds-stat-label">{label}</div>
      <div className="tds-stat-value">{value}</div>
    </div>
  );
}
